"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useCalculateZoom(zoom, fullWidth, naturalWidth, containerRef) {
    return (0, react_1.useMemo)(function () {
        if (!fullWidth || !naturalWidth)
            return "".concat(zoom, "%");
        var containerWidth = (containerRef === null || containerRef === void 0 ? void 0 : containerRef.clientWidth) || 0;
        if (!containerWidth)
            return "".concat(zoom, "%");
        var zoomPercentage = (naturalWidth / containerWidth) * 100;
        return "".concat(zoomPercentage < 100 ? zoom : zoomPercentage, "%");
    }, [zoom, fullWidth, naturalWidth, containerRef]);
}
exports.default = useCalculateZoom;
